import React from 'react';
import { Paper, Typography } from '@mui/material';
import { getAnalysisText } from './aiReportUtils';
import { fallbackStyles } from './styles';

export default function RegressionAnalysisFallback({ data, regressionId }) {
  return (
    <>
      <Typography variant="h6" sx={fallbackStyles.heading}>
        Regression {regressionId}
      </Typography>

      <Paper sx={fallbackStyles.regressionAnalysisPaper}>
        <Typography component="pre" sx={fallbackStyles.preAnalysisText}>
          {getAnalysisText(data)}
        </Typography>
      </Paper>
    </>
  );
}
